import React, { Component } from "react";
import {FaTwitter ,FaInstagram ,FaFacebookF , FaLinkedinIn } from "react-icons/fa";
import { FiX , FiMenu} from "react-icons/fi";
import Scrollspy from 'react-scrollspy'

interface Props {
    logo?: string;
    color?: string;
    homeLink?: string;
}

const SocialShare = [
    {Social: <FaFacebookF /> , link: 'https://www.facebook.com/kevinfvckingrifo'},
    {Social: <FaLinkedinIn /> , link: 'https://www.linkedin.com/in/kevin-rifo-buana-1919b8197/'},
    {Social: <FaInstagram /> , link: 'https://www.instagram.com/xyzonalyz'},
    {Social: <FaTwitter /> , link: 'https://twitter.com/ateisberiman'},
]
class HeaderThree extends Component<Props>{
    private scrollHandler: (() => void) | null = null;
    private menuTriggerRef: HTMLElement | null = null;
    private closeMenuTriggerRef: HTMLElement | null = null;

    constructor(props: Props) {
        super(props);
        this.menuTrigger = this.menuTrigger.bind(this);
        this.CLoseMenuTrigger = this.CLoseMenuTrigger.bind(this);
        this.stickyHeader = this.stickyHeader.bind(this);
        this.scrollToSection = this.scrollToSection.bind(this);
    }

    componentDidMount() {
        this.scrollHandler = () => {
            var value = window.scrollY;
            var header = document.querySelector('.header--fixed');
            if (header) {
                if (value > 100) {
                    header.classList.add('sticky');
                } else {
                    header.classList.remove('sticky');
                }
            }
        };
        window.addEventListener('scroll', this.scrollHandler);

        this.attachDropdownHandlers();
    }

    componentWillUnmount() {
        if (this.scrollHandler) {
            window.removeEventListener('scroll', this.scrollHandler);
        }
    }

    attachDropdownHandlers() {
        var elements = document.querySelectorAll('.has-droupdown > a');
        for(var i in elements) {
            if(elements.hasOwnProperty(i)) {
                (elements[i] as HTMLElement).onclick = function(this: HTMLElement) {
                    this.parentElement!.querySelector('.submenu')!.classList.toggle("active");
                    this.classList.toggle("open");
                }
            }
        }
    }

    menuTrigger() {
        document.querySelector('.header-wrapper')!.classList.toggle('menu-open')
    }
    
    CLoseMenuTrigger() {
        document.querySelector('.header-wrapper')!.classList.remove('menu-open')
    }

    scrollToSection(e: React.MouseEvent<HTMLAnchorElement>, id: string) {
        e.preventDefault();
        const el = document.getElementById(id);
        if (el) {
            const offset = 80;
            const y = el.getBoundingClientRect().top + window.pageYOffset - offset;
            window.scrollTo({ top: y, behavior: 'smooth' });
        }
        this.CLoseMenuTrigger();
    }

    stickyHeader () {}

    render(): React.ReactNode{
        const { logo, color='default-color' } = this.props;
        let logoUrl;
        if(logo === 'light'){
            logoUrl = <img src="/assets/images/logo/logo-light.png" alt="Digital Agency" />;
        }else if(logo === 'dark'){
            logoUrl = <img src="/assets/images/logo/logo-dark.png" alt="Digital Agency" />;
        }else if(logo === 'symbol-dark'){
            logoUrl = <img src="/assets/images/logo/logo-symbol-dark.png" alt="Digital Agency" />;
        }else if(logo === 'symbol-light'){
            logoUrl = <img src="/assets/images/logo/logo-symbol-light.png" alt="Digital Agency" />;
        }else{
            logoUrl = <img src="/assets/images/logo/logo.png" alt="Digital Agency" />;
        }
        
        return(
            <header className={`header-area header-style-two header--fixed ${color}`}>
                <div className="header-wrapper">
                    <div className="header-left d-flex align-items-center">
                        <div className="logo">
                            <a href={this.props.homeLink}>
                               <h3 style={{marginTop: '15px',fontSize: '30px'}}>Portfolio</h3>
                            </a>
                        </div>
                        <nav className="mainmenunav d-lg-block ml--50">
                            <Scrollspy className="mainmenu" items={['home','about','service','portfolio','artwork','contact']} currentClassName="is-current" offset={-200}>
                                <li><a href="#home" onClick={(e) => this.scrollToSection(e, 'home')}>Home</a></li>
                                <li><a href="#about" onClick={(e) => this.scrollToSection(e, 'about')}>About</a></li>
                                <li><a href="#service" onClick={(e) => this.scrollToSection(e, 'service')}>Service</a></li>
                                <li><a href="#portfolio" onClick={(e) => this.scrollToSection(e, 'portfolio')}>Portfolio</a></li>
                                <li><a href="#artwork" onClick={(e) => this.scrollToSection(e, 'artwork')}>Artwork</a></li>
                                <li><a href="#contact" onClick={(e) => this.scrollToSection(e, 'contact')}>Contact</a></li>
                            </Scrollspy>
                        </nav>
                    </div>
                    <div className="header-right">
                        <div className="social-share-inner">
                            <ul className="social-share social-style--2 color-black d-flex justify-content-start liststyle">
                                {SocialShare.map((val , i) => (
                                    <li key={i}><a href={`${val.link}`}>{val.Social}</a></li>
                                ))}
                            </ul>
                        </div>
                    
                        {/* Start Humberger Menu  */}
                        <div className="humberger-menu d-block d-lg-none pl--20">
                            <span onClick={this.menuTrigger} className="menutrigger text-white"><FiMenu /></span>
                        </div>
                        {/* End Humberger Menu  */}
                        <div className="close-menu d-block d-lg-none">
                            <span onClick={this.CLoseMenuTrigger} className="closeTrigger"><FiX /></span>
                        </div>
                    </div>
                </div>
            </header>
        )
    }
}
export default HeaderThree;